import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { G2ReviewFeedbackDialogComponent } from "./g2-review-feedback-dialog/g2-review-feedback-dialog.component";
import { G2ReviewFormDialogComponent } from "./g2-review-form-dialog/g2-review-form-dialog.component";
import { G2ReviewPromptDialogComponent } from "./g2-review-prompt-dialog/g2-review-prompt-dialog.component";

@NgModule({
  declarations: [
    G2ReviewPromptDialogComponent,
    G2ReviewFeedbackDialogComponent,
    G2ReviewFormDialogComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatProgressSpinnerModule,
  ],
})
export class G2ReviewModule {}
